package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class PomodoroItemQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectBySession(session_id: String, mapper: (
    id: String,
    session_id: String,
    source_type: String,
    source_id: String,
    custom_title: String?,
    priority: Long,
    order_index: Long,
    completed: Long,
    completed_at: Long?,
    estimated_minutes: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectBySessionQuery(session_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectBySession(session_id: String): Query<Pomodoro_item> =
      selectBySession(session_id) { id, session_id_, source_type, source_id, custom_title, priority,
      order_index, completed, completed_at, estimated_minutes, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Pomodoro_item(
      id,
      session_id_,
      source_type,
      source_id,
      custom_title,
      priority,
      order_index,
      completed,
      completed_at,
      estimated_minutes,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    session_id: String,
    source_type: String,
    source_id: String,
    custom_title: String?,
    priority: Long,
    order_index: Long,
    completed: Long,
    completed_at: Long?,
    estimated_minutes: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectById(id: String): Query<Pomodoro_item> = selectById(id) { id_, session_id,
      source_type, source_id, custom_title, priority, order_index, completed, completed_at,
      estimated_minutes, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_item(
      id_,
      session_id,
      source_type,
      source_id,
      custom_title,
      priority,
      order_index,
      completed,
      completed_at,
      estimated_minutes,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBySourceInSession(
    session_id: String,
    source_type: String,
    source_id: String,
    mapper: (
      id: String,
      session_id: String,
      source_type: String,
      source_id: String,
      custom_title: String?,
      priority: Long,
      order_index: Long,
      completed: Long,
      completed_at: Long?,
      estimated_minutes: Long?,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectBySourceInSessionQuery(session_id, source_type, source_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectBySourceInSession(
    session_id: String,
    source_type: String,
    source_id: String,
  ): Query<Pomodoro_item> = selectBySourceInSession(session_id, source_type, source_id) { id,
      session_id_, source_type_, source_id_, custom_title, priority, order_index, completed,
      completed_at, estimated_minutes, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_item(
      id,
      session_id_,
      source_type_,
      source_id_,
      custom_title,
      priority,
      order_index,
      completed,
      completed_at,
      estimated_minutes,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun maxOrderInSession(session_id: String): Query<Long> =
      MaxOrderInSessionQuery(session_id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectActiveItemsBySession(session_id: String, mapper: (
    id: String,
    session_id: String,
    source_type: String,
    source_id: String,
    custom_title: String?,
    priority: Long,
    order_index: Long,
    completed: Long,
    completed_at: Long?,
    estimated_minutes: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectActiveItemsBySessionQuery(session_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectActiveItemsBySession(session_id: String): Query<Pomodoro_item> =
      selectActiveItemsBySession(session_id) { id, session_id_, source_type, source_id,
      custom_title, priority, order_index, completed, completed_at, estimated_minutes, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_item(
      id,
      session_id_,
      source_type,
      source_id,
      custom_title,
      priority,
      order_index,
      completed,
      completed_at,
      estimated_minutes,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    session_id: String,
    source_type: String,
    source_id: String,
    custom_title: String?,
    priority: Long,
    order_index: Long,
    completed: Long,
    completed_at: Long?,
    estimated_minutes: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_982_448_896, arrayOf("pomodoro_item"), driver, "PomodoroItem.sq",
      "selectDirty",
      "SELECT pomodoro_item.id, pomodoro_item.session_id, pomodoro_item.source_type, pomodoro_item.source_id, pomodoro_item.custom_title, pomodoro_item.priority, pomodoro_item.order_index, pomodoro_item.completed, pomodoro_item.completed_at, pomodoro_item.estimated_minutes, pomodoro_item.created_at, pomodoro_item.updated_at, pomodoro_item.is_deleted, pomodoro_item.deleted_at, pomodoro_item.synced_at FROM pomodoro_item WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectDirty(): Query<Pomodoro_item> = selectDirty { id, session_id, source_type,
      source_id, custom_title, priority, order_index, completed, completed_at, estimated_minutes,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_item(
      id,
      session_id,
      source_type,
      source_id,
      custom_title,
      priority,
      order_index,
      completed,
      completed_at,
      estimated_minutes,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    session_id: String,
    source_type: String,
    source_id: String,
    custom_title: String?,
    priority: Long,
    order_index: Long,
    completed: Long,
    completed_at: Long?,
    estimated_minutes: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Pomodoro_item> = selectByIdAnyState(id) { id_,
      session_id, source_type, source_id, custom_title, priority, order_index, completed,
      completed_at, estimated_minutes, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_item(
      id_,
      session_id,
      source_type,
      source_id,
      custom_title,
      priority,
      order_index,
      completed,
      completed_at,
      estimated_minutes,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectAll(mapper: (
    id: String,
    session_id: String,
    source_type: String,
    source_id: String,
    custom_title: String?,
    priority: Long,
    order_index: Long,
    completed: Long,
    completed_at: Long?,
    estimated_minutes: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_289_552_975, arrayOf("pomodoro_item"), driver, "PomodoroItem.sq",
      "selectAll",
      "SELECT pomodoro_item.id, pomodoro_item.session_id, pomodoro_item.source_type, pomodoro_item.source_id, pomodoro_item.custom_title, pomodoro_item.priority, pomodoro_item.order_index, pomodoro_item.completed, pomodoro_item.completed_at, pomodoro_item.estimated_minutes, pomodoro_item.created_at, pomodoro_item.updated_at, pomodoro_item.is_deleted, pomodoro_item.deleted_at, pomodoro_item.synced_at FROM pomodoro_item WHERE is_deleted = 0 ORDER BY order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectAll(): Query<Pomodoro_item> = selectAll { id, session_id, source_type, source_id,
      custom_title, priority, order_index, completed, completed_at, estimated_minutes, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_item(
      id,
      session_id,
      source_type,
      source_id,
      custom_title,
      priority,
      order_index,
      completed,
      completed_at,
      estimated_minutes,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    session_id: String,
    source_type: String,
    source_id: String,
    custom_title: String?,
    priority: Long,
    order_index: Long,
    completed: Long,
    completed_at: Long?,
    estimated_minutes: Long?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_263_850_065, """
        |INSERT INTO pomodoro_item(
        |    id, session_id, source_type, source_id, custom_title, priority,
        |    order_index, completed, completed_at, estimated_minutes, created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 12) {
          bindString(0, id)
          bindString(1, session_id)
          bindString(2, source_type)
          bindString(3, source_id)
          bindString(4, custom_title)
          bindLong(5, priority)
          bindLong(6, order_index)
          bindLong(7, completed)
          bindLong(8, completed_at)
          bindLong(9, estimated_minutes)
          bindLong(10, created_at)
          bindLong(11, updated_at)
        }
    notifyQueries(-1_263_850_065) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun updateCompleted(
    completed: Long,
    completed_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(564_869_452, """
        |UPDATE pomodoro_item
        |SET completed = ?, completed_at = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 4) {
          bindLong(0, completed)
          bindLong(1, completed_at)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(564_869_452) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun updatePriority(
    priority: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-547_794_301, """
        |UPDATE pomodoro_item
        |SET priority = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 3) {
          bindLong(0, priority)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-547_794_301) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun updateOrder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_534_030_543, """
        |UPDATE pomodoro_item
        |SET order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_534_030_543) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_912_594_837,
        """UPDATE pomodoro_item SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_912_594_837) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-709_701_219,
        """UPDATE pomodoro_item SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-709_701_219) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun update(
    session_id: String,
    source_type: String,
    source_id: String,
    custom_title: String?,
    priority: Long,
    order_index: Long,
    completed: Long,
    completed_at: Long?,
    estimated_minutes: Long?,
    created_at: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-918_903_873, """
        |UPDATE pomodoro_item
        |SET session_id = ?, source_type = ?, source_id = ?, custom_title = ?, priority = ?, order_index = ?, completed = ?, completed_at = ?, estimated_minutes = ?, created_at = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 12) {
          bindString(0, session_id)
          bindString(1, source_type)
          bindString(2, source_id)
          bindString(3, custom_title)
          bindLong(4, priority)
          bindLong(5, order_index)
          bindLong(6, completed)
          bindLong(7, completed_at)
          bindLong(8, estimated_minutes)
          bindLong(9, created_at)
          bindLong(10, updated_at)
          bindString(11, id)
        }
    notifyQueries(-918_903_873) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun updateEstimatedMinutes(
    estimated_minutes: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-626_441_502,
        """UPDATE pomodoro_item SET estimated_minutes = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, estimated_minutes)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-626_441_502) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun updateQuick(
    custom_title: String?,
    estimated_minutes: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_535_971_694,
        """UPDATE pomodoro_item SET custom_title = ?, estimated_minutes = ?, updated_at = ? WHERE id = ?""",
        4) {
          bindString(0, custom_title)
          bindLong(1, estimated_minutes)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(1_535_971_694) { emit ->
      emit("pomodoro_item")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-1_384_266_152,
        """UPDATE pomodoro_item SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_384_266_152) { emit ->
      emit("pomodoro_item")
    }
  }

  private inner class SelectBySessionQuery<out T : Any>(
    public val session_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_036_902_803, """
    |SELECT pomodoro_item.id, pomodoro_item.session_id, pomodoro_item.source_type, pomodoro_item.source_id, pomodoro_item.custom_title, pomodoro_item.priority, pomodoro_item.order_index, pomodoro_item.completed, pomodoro_item.completed_at, pomodoro_item.estimated_minutes, pomodoro_item.created_at, pomodoro_item.updated_at, pomodoro_item.is_deleted, pomodoro_item.deleted_at, pomodoro_item.synced_at FROM pomodoro_item
    |WHERE session_id = ? AND is_deleted = 0
    |ORDER BY completed, priority, order_index, created_at
    """.trimMargin(), mapper, 1) {
      bindString(0, session_id)
    }

    override fun toString(): String = "PomodoroItem.sq:selectBySession"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_321_477_860,
        """SELECT pomodoro_item.id, pomodoro_item.session_id, pomodoro_item.source_type, pomodoro_item.source_id, pomodoro_item.custom_title, pomodoro_item.priority, pomodoro_item.order_index, pomodoro_item.completed, pomodoro_item.completed_at, pomodoro_item.estimated_minutes, pomodoro_item.created_at, pomodoro_item.updated_at, pomodoro_item.is_deleted, pomodoro_item.deleted_at, pomodoro_item.synced_at FROM pomodoro_item WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PomodoroItem.sq:selectById"
  }

  private inner class SelectBySourceInSessionQuery<out T : Any>(
    public val session_id: String,
    public val source_type: String,
    public val source_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_149_330_605, """
    |SELECT pomodoro_item.id, pomodoro_item.session_id, pomodoro_item.source_type, pomodoro_item.source_id, pomodoro_item.custom_title, pomodoro_item.priority, pomodoro_item.order_index, pomodoro_item.completed, pomodoro_item.completed_at, pomodoro_item.estimated_minutes, pomodoro_item.created_at, pomodoro_item.updated_at, pomodoro_item.is_deleted, pomodoro_item.deleted_at, pomodoro_item.synced_at FROM pomodoro_item
    |WHERE session_id = ?
    |  AND source_type = ?
    |  AND source_id = ?
    |  AND is_deleted = 0
    |LIMIT 1
    """.trimMargin(), mapper, 3) {
      bindString(0, session_id)
      bindString(1, source_type)
      bindString(2, source_id)
    }

    override fun toString(): String = "PomodoroItem.sq:selectBySourceInSession"
  }

  private inner class MaxOrderInSessionQuery<out T : Any>(
    public val session_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_257_092_143, """
    |SELECT COALESCE(MAX(order_index), -1) AS max_order
    |FROM pomodoro_item
    |WHERE session_id = ? AND is_deleted = 0
    """.trimMargin(), mapper, 1) {
      bindString(0, session_id)
    }

    override fun toString(): String = "PomodoroItem.sq:maxOrderInSession"
  }

  private inner class SelectActiveItemsBySessionQuery<out T : Any>(
    public val session_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_727_484_393, """
    |SELECT pomodoro_item.id, pomodoro_item.session_id, pomodoro_item.source_type, pomodoro_item.source_id, pomodoro_item.custom_title, pomodoro_item.priority, pomodoro_item.order_index, pomodoro_item.completed, pomodoro_item.completed_at, pomodoro_item.estimated_minutes, pomodoro_item.created_at, pomodoro_item.updated_at, pomodoro_item.is_deleted, pomodoro_item.deleted_at, pomodoro_item.synced_at FROM pomodoro_item
    |WHERE session_id = ? AND is_deleted = 0
    |ORDER BY order_index
    """.trimMargin(), mapper, 1) {
      bindString(0, session_id)
    }

    override fun toString(): String = "PomodoroItem.sq:selectActiveItemsBySession"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_854_739_721,
        """SELECT pomodoro_item.id, pomodoro_item.session_id, pomodoro_item.source_type, pomodoro_item.source_id, pomodoro_item.custom_title, pomodoro_item.priority, pomodoro_item.order_index, pomodoro_item.completed, pomodoro_item.completed_at, pomodoro_item.estimated_minutes, pomodoro_item.created_at, pomodoro_item.updated_at, pomodoro_item.is_deleted, pomodoro_item.deleted_at, pomodoro_item.synced_at FROM pomodoro_item WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PomodoroItem.sq:selectByIdAnyState"
  }
}
